// HTML select options only accept string values
export const policyNumberSelectOptions = [
  // Pilot states
  { label: '9112EU002218 - IL', value: '9112EU002218' },
  { label: '6132EU001912 - NC', value: '6132EU001912' },
  { label: '9234EU004459 - OH', value: '9234EU004459' },
  { label: '5837EU001187 - PA', value: '5837EU001187' },
  { label: '7842EU001548 - TX', value: '7842EU001548' },
  { label: '5345EU001253 - VA', value: '5345EU001253' },
  // Ineligible scenarios
  { label: '1234HR567890 - Not Found', value: '1234HR567890' },
  { label: '9234EU004462 - Not Active', value: '9234EU004462' },
  // - Agency not pilot eligible (ANX005)
  { label: '9234EU004470 - Agency Mismatch', value: '9234EU004470' },
  { label: '6139EU000767 - SC', value: '6139EU000767' },
  { label: '9234CU002512 - Condo', value: '9234CU002512' },
  { label: '9234EU004461 - Over 5k', value: '9234EU004461' },
  { label: '6132EU001915 - Townhouse', value: '6132EU001915' },
  { label: '9121EU000803 - Hist Reg - MI', value: '9121EU000803' }, // Added to LD pilot states in dev for testing
  // - Mobile or manufactured
  { label: '9234EU004460 - Equipment Breakdown', value: '9234EU004460' },
];

export const submissionNumberSelectOptions = [
  // Pilot states
  { label: '439957846656 - IL', value: '439957846656' },
  { label: '439914377856 - NC', value: '439914377856' },
  { label: '439923491712 - OH', value: '439923491712' },
  { label: '439937090432 - PA', value: '439937090432' },
  { label: '439931089536 - TX', value: '439931089536' },
  { label: '439945940096 - VA', value: '439945940096' },
  // Ineligible scenarios
  { label: '000123456789 - Not Found', value: '000123456789' },
  { label: '472341042944 - Bound', value: '472341042944' },
  { label: '439972547712 - Not Active', value: '439972547712' },
  // - Agency not pilot eligible (ANX005)
  { label: '440035033984 - Agency Mismatch', value: '440035033984' },
  { label: '439966256256 - SC', value: '439966256256' },
  { label: '440045980800 - Condo', value: '440045980800' },
  { label: '459967525888 - Townhouse', value: '459967525888' },
  { label: '440006849152 - Over 5k', value: '440006849152' },
  { label: '440012292992 - Hist Reg - MI', value: '440012292992' }, // Added to LD pilot states in dev for testing
  // - Mobile or manufactured
  { label: '440024760448 - Equipment Breakdown', value: '440024760448' },
];

export const axiomQuoteSelectOptions = [
  {
    label: 'Testy Tester - 123 Main St Columbus OH 43228 - 1999 sqft - homeservicecontract@nationwide.com',
    value: JSON.stringify({
      customer: {
        addressLine1: '123 Main St',
        city: 'Columbus',
        country: 'US',
        emailAddress: 'homeservicecontract@nationwide.com',
        firstName: 'Testy',
        lastName: 'Tester',
        stateProvinceRegion: 'OH',
        zipPostalCode: '43228',
      },
      propertySquareFootage: 1999,
    }),
  },
];
